import { cloneElement } from 'react';
import { downloadFile } from '../../utils/downloadFile';
export async function exportToCsv(gridElement, fileName) {
    const { head, body, foot } = await getGridContent(gridElement);
    const content = [...head, ...body, ...foot]
        .map((cells) => cells.map(serialiseCellValue).join(','))
        .join('\n');
    downloadFile(fileName, new Blob([content], { type: 'text/csv;charset=utf-8;' }));
}
export async function exportToXlsx(gridElement, fileName) {
    const [{ Workbook }, { head, body, foot }] = await Promise.all([
        import('exceljs'),
        getGridContent(gridElement),
    ]);
    const wb = new Workbook();
    const ws = wb.addWorksheet('Sheet 1');
    ws.addRows([...head, ...body, ...foot]);
    const buffer = await wb.xlsx.writeBuffer();
    downloadFile(fileName, new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    }));
}
async function getGridContent(gridElement) {
    const { renderToStaticMarkup } = await import('react-dom/server');
    const grid = document.createElement('div');
    grid.innerHTML = renderToStaticMarkup(cloneElement(gridElement, {
        enableVirtualization: false,
    }));
    return {
        head: getRows('.rdg-header-row'),
        body: getRows('.rdg-row:not(.rdg-summary-row)'),
        foot: getRows('.rdg-summary-row'),
    };
    function getRows(selector) {
        return Array.from(grid.querySelectorAll(selector)).map((gridRow) => {
            return Array.from(gridRow.querySelectorAll('.rdg-cell')).map((gridCell) => gridCell.innerText);
        });
    }
}
function serialiseCellValue(value) {
    if (typeof value === 'string') {
        const formattedValue = value.replace(/"/g, '""');
        return formattedValue.includes(',') ? `"${formattedValue}"` : formattedValue;
    }
    return value;
}
